module.exports = require('./helpers/bundle-url').getBundleURL('2i3Nj') + "logo-dark.ba5147f0.svg";